import axios from 'axios';

async function ObtenerPrestadoresEspecialidad( prmEspecialidad: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_prestadores_especialidad"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_especialidad": prmEspecialidad
        });
        return response.data
    } catch (error) {
        return error;
    }
};

export default ObtenerPrestadoresEspecialidad;